var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 35,
    viewBox: "0 0 25 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63086 20.8203L3.89985 30.0177C3.91956 30.6916 4.64597 31.1054 5.23569 30.7786L13.6482 26.1169",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9499 4.52916L19.6727 5.97726C21.1356 6.75524 21.6908 8.57178 20.9128 10.0346L20.1832 11.4064C19.1099 9.88708 17.5663 8.7847 16.0394 8.05689C14.7355 7.43538 13.3867 7.05999 12.2672 6.94501L12.8925 5.76921C13.6705 4.30637 15.487 3.75118 16.9499 4.52916ZM19.2829 12.7787L19.529 12.6366L12.9933 24.9256C11.9251 23.475 10.4276 22.4159 8.94577 21.7096C7.57939 21.0583 6.16364 20.6772 5.01415 20.5829L11.4892 8.40777C12.4282 8.38977 13.9033 8.70037 15.394 9.41093C16.9462 10.1508 18.4161 11.2775 19.2829 12.7787ZM11.6871 25.6849C10.8107 24.5514 9.58365 23.6753 8.30035 23.0636C7.06977 22.477 5.84982 22.163 4.93333 22.0814L2.62917 20.852C2.68784 20.7126 2.75332 20.5746 2.82572 20.4385L11.1267 4.8301C12.4233 2.39203 15.4509 1.46672 17.889 2.76335L20.6118 4.21145C23.0499 5.50808 23.9752 8.53566 22.6786 10.9737L14.3776 26.5821C14.3024 26.7235 14.2214 26.8599 14.135 26.991L11.6871 25.6849Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChange);
export default __webpack_public_path__ + "static/media/IconChange.a01c2464cd1aa6317f97b28209c3899c.svg";
export { ForwardRef as ReactComponent };